// components/MessageCotnainer.js

import React, { memo } from 'react';
import { Paper, Divider } from '@mui/material';
import DisplayedMessage from './DisplayedMessage'; // Adjust the path as necessary

const MessagesContainer = memo(({ messages, replaceSourceWithComponent, messagesEndRef }) => {
  return (
    <Paper sx={{ flexGrow: 1, overflowY: 'auto', padding: 2 }}>
      {messages.map((message, index) => (
        <React.Fragment key={index}>
          {index === messages.length - 1 && <div ref={messagesEndRef} />}
          <DisplayedMessage
            message={message}
          />
          {index < messages.length - 1 && <Divider />}  {/* Divider managed here */}
        </React.Fragment>
      ))}
      
    </Paper>
  );
});

export default MessagesContainer;
